import {useBackgroundStyleConfigs} from 'hooks/useBackgroundStyleConfigs';
import React, {FC} from 'react';

import {TypoComponentsTitleWithOptionalBreadcrumb} from 'lib/api/strapi';

import {Box, Typography} from 'components/basic-components';
import Breadcrumb from 'components/basic-components/Breadcrumb/Breadcrumb';
import MarkdownContent from 'components/basic-components/MarkdownContent';
import {withErrorBoundary} from 'components/error/ErrorBoundary';

import styles from './TitleWithBreadcrumb.module.scss';

const TitleWithBreadcrumb: FC<TypoComponentsTitleWithOptionalBreadcrumb> = ({
  title,
  textContent,
  titleLevel,
  breadcrumb,
}) => {
  const {textColor} = useBackgroundStyleConfigs();
  return (
    <Box
      sx={{
        padding: {xxs: '20px 0 0 0', md: '40px 0'},
        color: textColor,
      }}
    >
      {breadcrumb?.length > 0 ? <Breadcrumb link={breadcrumb} /> : null}
      {title ? (
        <Typography
          sx={{
            typography: {xxs: 'teaser', md: 'h1'},
            marginTop: breadcrumb?.length > 0 ? '15px' : null,
          }}
          className={styles.title}
          component={titleLevel}
        >
          {title}
        </Typography>
      ) : null}
      {textContent ? (
        <Box sx={{marginTop: '20px'}}>
          <MarkdownContent content={textContent} />
        </Box>
      ) : null}
    </Box>
  );
};

export default withErrorBoundary(TitleWithBreadcrumb, ' TitleWithBreadcrumb');
